module.exports = __webpack_public_path__ + "static/media/typeface@x2.0f3a15fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/typeface@x2.png
// module id = 553
// module chunks = 0